import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import ListingTable from "../../components/GroupListingTable";

function GroupListingScreen() {
  return (
    <BaseLayout paddingTop>
      <ListingTable />
    </BaseLayout>
  );
}

export default GroupListingScreen;
